import { createSvgIcon } from '@mui/material';
import { ReactNode } from 'react';

const svg: ReactNode = (
  <>
    <path d="M20 7H15V2L20 7Z" fill="currentColor" />
    <path
      d="M14 8V2H6.286C5.023 2 4 2.895 4 4V20C4 21.105 5.023 22 6.286 22H17.715C18.977 22 20 21.105 20 20V8H14ZM15 18H7V17H15V18ZM17 16H7V15H17V16ZM17 14H7V13H17V14ZM17 12H7V11H17V12Z"
      fill="currentColor"
    />
  </>
);

const Icon = createSvgIcon(svg, 'FileText');

export default Icon;
